import React from 'react'

export default function IPreferAirLogo({ className, size = 24, ...props }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 61 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="ipreferair-mask"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="61"
                height="94"
            >
                <path d="M60.2657 0H0V93.3798H60.2657V0Z" fill="white" />
            </mask>
            <g mask="url(#ipreferair-mask)">
                <path
                    d="M30.3046 3.83647H30.3271L30.5 3.83594H30.5055C45.242 3.83891 57.1875 15.8621 57.1875 30.6931V63.3053C57.1875 78.1381 45.2391 90.1625 30.5 90.1625C15.7609 90.1625 3.8125 78.1381 3.8125 63.3053V63.0546V30.6931V30.3236C3.8125 15.6967 15.5935 3.83893 30.1273 3.83594H30.1329L30.3046 3.83647Z"
                    stroke="currentColor"
                    strokeWidth="6"
                />
                <path
                    d="M33.4541 20.7444C33.4541 18.8835 31.955 17.375 30.106 17.375C28.2569 17.375 26.7578 18.8835 26.7578 20.7444C26.7578 22.6052 28.2569 24.1138 30.106 24.1138C31.955 24.1138 33.4541 22.6052 33.4541 20.7444Z"
                    fill="currentColor"
                />
                <path
                    d="M22.3648 66.1247C22.4161 65.8797 22.592 65.68 22.8274 65.5996L29.6482 63.268C29.7944 63.2181 29.953 63.218 30.0992 63.2674L37.0031 65.6027C37.2356 65.6815 37.4108 65.8764 37.4655 66.1172L38.5855 71.0627C38.7029 71.5817 38.2318 72.0409 37.7204 71.9062L30.0538 69.8893C29.9357 69.8582 29.8118 69.8584 29.6938 69.8902L22.1991 71.9041C21.6917 72.0405 21.2197 71.5901 21.3282 71.0729L22.3648 66.1247Z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M27.0166 35.1851C27.0166 33.5058 28.3693 32.1445 30.038 32.1445C31.7068 32.1445 33.0594 33.5058 33.0594 35.1851V47.0671L33.0207 47.0466C32.4773 46.7565 31.8777 47.0303 31.755 47.6244L30.7887 52.2956C30.6778 52.8324 31.0037 53.4167 31.5167 53.6009L33.0594 54.1545V66.8948H27.0166V54.2347C27.3504 54.1148 27.2612 53.1829 27.139 50.2487C27.0166 47.3144 27.0166 48.0119 27.0166 47.0466V35.1851ZM27.0166 47.0466V54.2347L15.6987 58.3222C15.0473 58.5558 14.457 58.0342 14.5583 57.3143L14.9957 54.2057C15.0478 53.8357 15.278 53.5013 15.5982 53.3304L27.0166 47.0466ZM33.0594 54.1545L44.7514 58.3511C45.4028 58.585 45.9932 58.0632 45.8917 57.3432L45.4543 54.2347C45.4022 53.8647 45.1721 53.5303 44.8519 53.3594L33.0594 47.0671V54.1545Z"
                    fill="currentColor"
                />
                <path
                    d="M31.7536 47.624L30.7873 52.2952C30.6764 52.8319 31.0023 53.4163 31.5153 53.6004L33.058 54.1541V47.0667L33.0193 47.0461C32.4758 46.7561 31.8763 47.0298 31.7536 47.624Z"
                    fill="currentColor"
                />
                <path
                    d="M27.0156 47.0469V54.235C27.3494 54.1151 27.2602 53.1832 27.138 50.249C27.0156 47.3147 27.0156 48.0122 27.0156 47.0469Z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
}
